import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export const useEvent = (event, handler, passive = false) => {
  useEffect(() => {
    // initiate the event handler
    window.addEventListener(event, handler, passive)

    // this will clean up the event every time the component is re-rendered
    return () => {
      window.removeEventListener(event, handler)
    }
  })
}

export const useElementEvent = (event, handler, element, passive = false) => {
  useEffect(() => {
    if (element) {
      // initiate the event handler
      element.addEventListener(event, handler, passive)

      // this will clean up the event every time the component is re-rendered
      return () => {
        element.removeEventListener(event, handler)
      }
    }
  }, [element, handler, event])
}

export function useQuery() {
  return new URLSearchParams(useLocation().search)
}

export const usePrevious = (value) => {
  const prev = useRef()
  useEffect(() => {
    prev.current = value
  }, [value])

  return prev.current
}

export const useParallax = (start) => {
  useEffect(() => {
    if (start) {
      const slide = document.querySelector('#slide')
      if (slide) {
        slide.addEventListener('mousemove', function (e) {
          // Get dimensions of slide element
          const r = slide.getBoundingClientRect()

          // Set x and y values prop values based on center of slide element
          slide.style.setProperty('--x', e.clientX - (r.left + Math.floor(r.width / 2)))
          slide.style.setProperty('--y', e.clientY - (r.top + Math.floor(r.height / 2)))
        })

        slide.addEventListener('mouseleave', function () {
          // Reset x and y prop values when no longer hovering
          slide.style.setProperty('--x', 0)
          slide.style.setProperty('--y', 0)
        })
      }
    }
  })
}
